/**
 * Power BI report and dataset IDs, sourced from environment variables.
 *
 * These values are injected at build time via VITE_PBI_* environment
 * variables. Set them in:
 *   - .env.development       (local dev)
 *   - GitHub Secrets         (CI/CD builds)
 *
 * See docs/Site Wide Plan/07-powerbi-env-vars.md for the full variable list.
 */
export const powerbiConfig = {
  home: {
    reportId: import.meta.env.VITE_PBI_HOME_REPORT_ID as string,
    datasetId: import.meta.env.VITE_PBI_HOME_DATASET_ID as string,
  },
  dashboards: {
    // The three top Financials charts. Slot keys are named for the tab they
    // back; the env vars are intentionally the EXISTING, already-provisioned
    // VITE_PBI_* names so no GitHub Variables / CI / Dockerfile changes are
    // needed to ship. To point a chart at a different report, update the
    // *value* of the matching GitHub repo Variable (the name stays put).
    // NOTE: a slot may intentionally read a differently-named env var — the
    // VITE_PBI_* name is only a provisioning handle; the slot->value mapping
    // below is authoritative. Per the Power BI team's Confluence mapping
    // (Athena Power Bi Report Environment Variables), the two ITD reports are
    // swapped vs the original names:
    //   ITD Financial Summary  -> BURN_RATE report/dataset   (was ACTUAL_COSTS)
    //   GFEBS Financial Summary -> LINE_ITEMS report/dataset
    //   ITD Financial Details  -> ACTUAL_COSTS report/dataset (was BURN_RATE)
    itdFinancialSummary: {
      reportId: import.meta.env.VITE_PBI_BURN_RATE_REPORT_ID as string,
      datasetId: import.meta.env.VITE_PBI_BURN_RATE_DATASET_ID as string,
    },
    gfebsFinancialSummary: {
      reportId: import.meta.env.VITE_PBI_LINE_ITEMS_REPORT_ID as string,
      datasetId: import.meta.env.VITE_PBI_LINE_ITEMS_DATASET_ID as string,
    },
    itdFinancialDetails: {
      reportId: import.meta.env.VITE_PBI_ACTUAL_COSTS_REPORT_ID as string,
      datasetId: import.meta.env.VITE_PBI_ACTUAL_COSTS_DATASET_ID as string,
    },
  },
  masterSchedule: {
    reportId: import.meta.env.VITE_PBI_MASTER_SCHEDULE_REPORT_ID as string,
    datasetId: import.meta.env.VITE_PBI_MASTER_SCHEDULE_DATASET_ID as string,
  },
};
